import Swal from "sweetalert2";
import axios from "axios";
import { Trash2 } from "lucide-react";

const DeleteDismantleButton = ({ id, token, onSuccess }) => {
  const handleDelete = async () => {
    const confirm = await Swal.fire({
      title: "Yakin hapus data?",
      text: "Data dismantle ini akan dihapus permanen",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, hapus",
      cancelButtonText: "Batal",
      reverseButtons: true,
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await axios.delete(
        `https://api.wifikamu.my.id/dismantle-list/${id}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      // SUCCESS
      if (res.data.success) {
        await Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: res.data.message,
        });

        // refresh data di parent
        if (typeof onSuccess === "function") {
          onSuccess();
        }
      } else {
        // FAIL tapi bukan error server
        await Swal.fire({
          icon: "warning",
          title: "Gagal",
          text: res.data.message,
        });
      }

    } catch (error) {
      const message =
        error.response?.data?.message ||
        "Terjadi kesalahan pada server";

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: message,
      });
    }
  };

  return (
    <button
      onClick={handleDelete}
      className="flex items-center gap-1 px-3 py-1.5 text-sm text-white bg-red-600 hover:bg-red-700 rounded"
      title="Hapus data"
    >
      <Trash2 size={16} />
      Hapus
    </button>
  );
};

export default DeleteDismantleButton;
